import type { ReactNode } from 'react';
import logo from '../../assets/logos/quadroam-logo.svg';
import { BRAND } from '../../brand';

export function AuthShell({ title, subtitle, children }: { title: string; subtitle?: ReactNode; children: ReactNode }) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-mist px-4 py-10">
      <div className="w-full max-w-sm space-y-6">
        <img src={logo} alt={BRAND} className="h-8 w-auto" />
        <div className="space-y-5 rounded-lg border border-line bg-white p-6">
          <div className="space-y-1">
            <h1 className="font-display text-xl font-bold text-ink">{title}</h1>
            {subtitle && <p className="text-sm text-ink-muted">{subtitle}</p>}
          </div>
          {children}
        </div>
        <p className="text-center text-xs text-ink-muted">Links en q-r.cl</p>
      </div>
    </main>
  );
}
